export const ProductDisclosureEnglish = 'https://www.princesshouse.com/en-US/product-disclosures';
export const ProductDisclosureSpanish = 'https://www.princesshouse.com/es-US/product-disclosures';
export const LanguageCodeEnglish = 'en';
export const LanguageCodeSpanish = 'es';
export const LanguageCodeEnglishUS = 'en-US';
export const LanguageCodeSpanishUS = 'es-US';
